// Single source of truth for dashboard metric-tile icons.
//
// Icons are keyed by the metric key (the tile's *subject*), NOT by role — so the
// same metric shows the same glyph on every dashboard (admin, telesales, field,
// storekeeper, shipping). Sold vs returned vs bulk vs C/O variants of one product
// deliberately share the product glyph; the tile's colour tone + label tell those
// states apart. This keeps the wall of tiles legible instead of a glyph zoo.
//
// Every glyph below is registered in src/assets/icons/icons.js `iconsSet`; the
// bottle / leaf / weight product marks were vendored into iconsax.js for this.

export const TILE_ICONS = {
  // Bottles → bottle; returned adds a back-arrow, bulk doubles the bottle.
  bottles_sold_today: 'cil-bottle',
  bottles_returned: 'cil-bottle-return',
  returned_bottles: 'cil-bottle-return',
  bulk_bottles: 'cil-bottles',
  co_bottles_got: 'cil-bottle',

  // Farm bottles → bottle marked with a leaf; returned adds a back-arrow, bulk doubles it.
  farm_bottles_sold: 'cil-bottle-leaf',
  farm_bottles_returned: 'cil-bottle-leaf-return',
  bulk_farm_bottles: 'cil-bottles-leaf',
  co_farm_bottles_got: 'cil-bottle-leaf',

  // Kgs → weight; returned adds a back-arrow, bulk doubles the weight.
  kgs_sold: 'cil-weight',
  kgs_returned: 'cil-weight-return',
  returned_kgs: 'cil-weight-return',
  bulk_kgs: 'cil-weights',
  co_kgs_got: 'cil-weight',

  // Orders & sales activity
  no_of_orders_today: 'cil-basket',
  my_co_orders: 'cil-share-arrow',
  my_online_orders: 'cil-cart',
  total_bulk_orders: 'cil-package',
  no_of_calls_today: 'cil-phone',
  conversion_rate: 'cil-infinity',
  patients_visited: 'cil-user',
  hms_patients_attributed: 'cil-people',

  // Money
  sales_amount: 'cil-rupee',
  pending_payment: 'cil-credit-card',
  return_amount: 'cil-rupee-refund',

  // Returns (aggregate, not product-specific)
  return_rate: 'cil-chart-pie',
  returns: 'cil-refund',

  // Shipping dashboard — shipment-stage tiles (distinct domain, icon by stage)
  to_be_shipped_count: 'cil-box',
  not_scanned_count: 'cil-scan',
  batchable_orders: 'cil-layers',
  ready_to_ship_count: 'cil-truck',
  mailed_to_courier_count: 'cil-route',
  ready_to_ship_flipkart_count: 'cil-flipkart',
  ready_to_ship_amazon_count: 'cil-amazon',
}

// Fallback keeps an unmapped/new metric from rendering blank.
export function tileIcon (key) {
  return TILE_ICONS[key] || 'cil-chart-pie'
}
